import {
  Icon,
  IconButton,
  LayoutGridIcon,
  SparklesIcon,
  ToggleButton,
  ToggleGroup,
  Tooltip,
} from 'src/design-system/ui'

import './portal-mode-switcher.css'

export type PortalMode = 'portal' | 'agent'

const PortalModeSwitcher = ({
  expanded,
  mode,
  onChange,
}: {
  expanded: boolean
  mode: PortalMode
  onChange: (mode: PortalMode) => void
}) => {
  if (!expanded) {
    const nextMode = mode === 'agent' ? 'portal' : 'agent'
    const label = mode === 'agent' ? 'Open Portal' : 'Open AI Agent'

    return (
      <div className="ds:flex ds:justify-center ds:py-1">
        <Tooltip content={label} placement="right">
          <IconButton aria-label={label} onPress={() => onChange(nextMode)}>
            <Icon icon={mode === 'agent' ? LayoutGridIcon : SparklesIcon} />
          </IconButton>
        </Tooltip>
      </div>
    )
  }

  return (
    <ToggleGroup
      aria-label="Portal mode"
      className="portal-mode-switcher"
      appearance="segmented"
      disallowEmptySelection
      fullWidth
      selectionMode="single"
      selectedKeys={[mode]}
      onSelectionChange={(keys) => {
        const next = keys.has('portal')
          ? 'portal'
          : keys.has('agent')
            ? 'agent'
            : null
        if (next && next !== mode) onChange(next)
      }}
    >
      <ToggleButton id="portal" appearance="segmented">
        <Icon icon={LayoutGridIcon} size="xs" tone="current" />
        Portal
      </ToggleButton>
      <ToggleButton id="agent" appearance="segmented">
        <Icon icon={SparklesIcon} size="xs" tone="current" />
        AI Agent
      </ToggleButton>
    </ToggleGroup>
  )
}

export default PortalModeSwitcher
